export enum LoadingIndicator {
  OPERATOR,
  MANUAL,
  ASYNC_PIPE,
}
